import { Component, State, Prop, Event, EventEmitter, Method, h, Host} from '@stencil/core';
import {overrideSettings} from "../../utils/utils";
import { v4 as uuidv4 } from 'uuid';

interface keyable {
  [key: string]: any,
}

@Component({
  tag: 'fdi-text-input',
  styleUrl: 'fdi-text-input.scss',
  shadow: true,
})

export class FDITextInput {

  @Prop() __value: string = '';
  @Prop() __settings: any;

  @State() uuid: string;
  @State() value: string;
  @State() oldValue: string;
  @State() input: HTMLInputElement|HTMLTextAreaElement;
  @State() settings: any = {
    growBasedOnInput: false,
    disabled: false,
    placeholder: '',
    style: false, // Set as object to use those styles
    class: 'fdi wc text',
    fontSize: '20px',
    minWidth: '100px',
    resize: 'vertical',
    flex: 1,
    margin: 0,
    meta: {},
    validation: {
      allowedValues: {
        value: [],
        html: ''
      },
      allowEmptyValues: {
        value: true,
        html: ''
      },
    },
    useTextArea: false,
  };

  @Method()
  async focusInput() {
    if (this.input) {
      this.input.focus();
    }
  }

  @Event({
    eventName: 'fdi_wc_input_change',
    bubbles: true,
    cancelable: true,
  }) inputChanged: EventEmitter

  handleChange(e){
    this.value = e.target.value;
    this.inputChanged.emit({
      newValue: this.value,
      oldValue: this.oldValue,
      hasError: this.getErrorData().error,
      meta: this.settings.meta,
      uuid: this.uuid,
    });
  }

  getErrorData() {

    const value = this.value || this.__value;

    // Checks whether empty values are allowed, and validates value against that condition.
    let invalidValue = !!(!value && !this.settings.validation.allowEmptyValues.value);
    if (invalidValue) {
       return {
          error: true,
          msg: this.settings.validation.allowEmptyValues.html,
       };
    }

    // Checks whether there is a range of valid values, and validates value against valid values. 
    invalidValue = !!(value && this.settings.validation.allowedValues.value.length && !this.settings.validation.allowedValues.value.includes(value));
    if (invalidValue) {
      return {
          error: true,
          msg: this.settings.validation.allowedValues.html,
      };
    }

    return {
      error: false,
      msg: ''
    };
  }

  componentWillLoad(){
    let settings = this.__settings;

    if ( typeof settings === 'string' ){
      settings = JSON.parse( this.__settings );
    }

    this.settings = overrideSettings( this.settings, settings );
    this.uuid = uuidv4();
  }

  render() {
    let value = this.__value;

    // If style isn't specified, then use the other settings
    let style: keyable = this.settings.style;
    if (!style) {
      style = {
        fontSize: this.settings.fontSize,
        minWidth: this.settings.minWidth,
        width: this.settings.width,
        margin: this.settings.margin,
        resize: this.settings.resize,
        flex: this.settings.flex,
      };

      if ( this.settings.growBasedOnInput ){
        let val = this.value || value;
        style.width = `${val.length * parseInt( this.settings.fontSize ) / 2.10 }px`;
      }
    }

    return (
      <Host>
        {this.settings.useTextArea ? (
          <textarea
            class={this.settings.class}
            style={this.getErrorData().error ? {...style, ...{background: 'red', color: 'white'}} : style}
            placeholder={ this.settings.placeholder }
            disabled={ this.settings.disabled }
            value={ value }
            onInput={ (e) => { this.handleChange(e) } }
            ref={(el) => this.input = el}
          />
        ) : (
          <input
            class={this.settings.class}
            style={this.getErrorData().error ? {...style, ...{background: 'red', color: 'white'}} : style}
            placeholder={ this.settings.placeholder }
            disabled={ this.settings.disabled }
            value={ value }
            onInput={ (e) => { this.handleChange(e) } }
            ref={(el) => this.input = el}
          />
        )}
        
        {
          this.getErrorData().error && 
          <div style={{fontSize: '12px', background: 'red', color: 'white', padding: '5px'}} innerHTML={this.getErrorData().msg || 'Invalid value.'}></div>
        }
      </Host>
    );
  }
}
